import React, { useState, useEffect } from 'react';

const DISMISS_KEY = 'facto-pwa-install-dismissed';

export default function InstallBanner() {
  const [prompt, setPrompt] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Déjà installé en mode standalone
    if (window.matchMedia('(display-mode: standalone)').matches) return;
    // Déjà refusé par l'utilisateur
    if (localStorage.getItem(DISMISS_KEY)) return;

    const handler = (e) => {
      e.preventDefault();
      setPrompt(e);
      setVisible(true);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  if (!visible || !prompt) return null;

  const handleInstall = async () => {
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    if (outcome === 'dismissed') {
      localStorage.setItem(DISMISS_KEY, '1');
    }
    setVisible(false);
    setPrompt(null);
  };

  const handleDismiss = () => {
    localStorage.setItem(DISMISS_KEY, '1');
    setVisible(false);
  };

  return (
    <div className="install-banner" role="banner" aria-label="Installer l'application">
      <img
        src="/icons/icon-192.png"
        alt="Facto"
        className="install-banner-icon"
      />
      <div className="install-banner-text">
        <strong>Installer Facto</strong>
        <span>Accès rapide depuis votre écran d'accueil</span>
      </div>
      <button className="btn btn-primary btn-sm" onClick={handleInstall}>
        Installer
      </button>
      <button
        className="install-banner-close"
        onClick={handleDismiss}
        aria-label="Fermer"
      >
        ✕
      </button>
    </div>
  );
}
